var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPWhiteGreenWaterBgRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "#089191"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05337 7.7645C8.27537 7.7645 8.46887 7.7375 8.63387 7.6835C8.79887 7.6265 8.93537 7.547 9.04337 7.445C9.15437 7.34 9.23687 7.214 9.29087 7.067C9.34487 6.917 9.37187 6.7505 9.37187 6.5675C9.37187 6.3935 9.34487 6.236 9.29087 6.095C9.23687 5.954 9.15587 5.834 9.04787 5.735C8.93987 5.636 8.80337 5.561 8.63837 5.51C8.47337 5.456 8.27837 5.429 8.05337 5.429H7.14887V7.7645H8.05337ZM8.05337 4.493C8.48837 4.493 8.86487 4.544 9.18287 4.646C9.50087 4.748 9.76337 4.8905 9.97037 5.0735C10.1774 5.2565 10.3304 5.4755 10.4294 5.7305C10.5314 5.9855 10.5824 6.2645 10.5824 6.5675C10.5824 6.8825 10.5299 7.172 10.4249 7.436C10.3199 7.697 10.1624 7.922 9.95237 8.111C9.74237 8.3 9.47837 8.447 9.16037 8.552C8.84537 8.657 8.47637 8.7095 8.05337 8.7095H7.14887V11H5.93837V4.493H8.05337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPWhiteGreenWaterBgRounded);
export default __webpack_public_path__ + "static/media/pWhiteGreenWaterBgRounded.4b7652d2fabef388f15bafa00fd32e58.svg";
export { ForwardRef as ReactComponent };